import * as tslib_1 from "tslib";
import getSweepRulesService from '../services/getSweepRulesService';
import store from '../store/store';
import { map } from 'mobx';
import { action } from 'satcheljs/lib/legacy';
import setSweepRuleRequestStatus from 'owa-sweep-rules-option/lib/actions/setSweepRuleRequestStatus';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
/**
 * Gets sweep rules and stores them in the sweepRules options store
 */
export default action('getSweepRules')(function getSweepRules() {
    store.sweepRuleIds = [];
    store.sweepRules = map({});
    setSweepRuleRequestStatus(1 /* Pending */);
    return getSweepRulesService()
        .then(function (response) {
        var sweepResponseMessage = response.Body.ResponseMessages
            .Items[0];
        if (sweepResponseMessage.ResponseClass === 'Success') {
            var sweepRuleCollection = sweepResponseMessage.SweepRulesForUser;
            for (var _i = 0, sweepRuleCollection_1 = sweepRuleCollection; _i < sweepRuleCollection_1.length; _i++) {
                var sweepRule = sweepRuleCollection_1[_i];
                var ewsSweepRule = sweepRule;
                addSweepRuleToStore(ewsSweepRule);
            }
            var _a = datapoints.numSweepRules.datapoint, eventName = _a.name, customData = _a.customData;
            logUsage(eventName, customData(sweepRuleCollection.length));
            store.hasLoggedGetSweepRulesInformation = true;
            setSweepRuleRequestStatus(2 /* Complete */);
        }
        else {
            setSweepRuleRequestStatus(3 /* Error */);
        }
        return true;
    })
        .catch(function (error) {
        setSweepRuleRequestStatus(3 /* Error */);
        return true;
    });
});
var addSweepRuleToStore = action('addSweepRuleToStore')(function addSweepRuleToStore(sweepRule) {
    var ruleId = sweepRule.RuleId;
    if (!store.hasLoggedGetSweepRulesInformation) {
        var _a = datapoints.sweepRuleInfo.datapoint, eventName = _a.name, customData = _a.customData;
        logUsage(eventName, customData(sweepRule));
    }
    store.sweepRuleIds.push(ruleId);
    store.sweepRules.set(ruleId, tslib_1.__assign({}, sweepRule));
});
//# sourceMappingURL=getSweepRules.js.map